import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

interface ProductApprovalsBulkActionSelectAllEntityParams {
  selectedProducts: number[];
}
export class ProductApprovalsBulkActionSelectAllEntity extends BaseEntityClass {
  selected_products: number[];
  constructor(params: ProductApprovalsBulkActionSelectAllEntityParams) {
    super();
    this.type = "product_approvals_bulk_actions_select_all";
    this.entity_version = 2;
    this.selected_products = params.selectedProducts;
  }
}
